import { find, html } from 'fxjs/es';
import { OMPCoreAtomTmplS } from '../../../Atom/S/Tmpl/module/OMPCoreAtomTmplS.js';
import { UtilS } from '../../../../../Util/S/Function/module/UtilS.js';
import { OMPCoreCellTmplS } from '../../../Cell/S/Tmpl/module/OMPCoreCellTmplS.js';
import { SubInteractiveMenu } from '../../../../../../services/Marpple/client/widgets/sub-menu/sub-interactive-menu/sub-interactive-menu.ts';
import { SubMenuSwiper } from '../../../../../../services/Marpple/client/widgets/sub-menu/sub-menu-swiper/sub-menu-swiper.ts';
import { SubMenuNavAll } from '../../../../../../services/Marpple/client/widgets/sub-menu/sub-menu-nav-all/sub-menu-nav-all.ts';

/**
 * @param {string} type
 * @param {!string} search_value
 */
const headerSearchFormHTML = (type, search_value) => {
  const TITLE_MAP = {
    default: 'search::search_01',
    detail: 'search::search_01_detail',
  };
  return OMPCoreAtomTmplS.searchForm({
    placeholder: TT(TITLE_MAP[type] || 'search::search_01'),
    value: UtilS.escape(search_value),
    input_klass: `omp-atom__input-auto-complete ${type}`, // TODO @kjj `AutoCompleteInput` 으로 랩핑하기
    form_klass: `omp-search__search-form ${type}`,
    data: { debounce_time: 300 },
  });
};

const defaultHeaderMenu = ({ sub_menu_all, sub_menus }) => {
  return html`
    ${OMPCoreAtomTmplS.headerDivMenu(sub_menu_all)}
    ${OMPCoreCellTmplS.headerMenus({
      buttons: sub_menus,
    })}
  `;
};

/**
 * @param {object} [param = {}]
 * @param {string} param.type
 * @param {object} param.locals
 * @param {string} param.title
 * @param {CateList[] | null} param.sub_menus
 * @param {boolean} [param.is_back]
 * @param {HeaderSearchParam} [locals.search = {}]
 * @param {object[] | null} param.sub_interactive_items
 */
export const pcTabletHTML = (param = {}) => {
  const TEMPLATE = {
    home: defaultHeaderHTML,
    search: defaultHeaderHTML,
    basic: defaultHeaderHTML,
    detail: detailHeaderHTML,
  };
  return TEMPLATE[param.type] ? TEMPLATE[param.type](param) : defaultHeaderHTML(param);
};

const defaultHeaderHTML = ({
  sub_menu_all,
  sub_menus,
  wish_count,
  cart_count,
  search_value,
  header_banner_type,
  sub_interactive_items,
} = {}) => {
  const headerBannerHTML = () => {
    if (!header_banner_type) return '';
    const BANNER_BG_COLOR_CODE = '#E8E8E8'; // 띠배너 배경코드
    return html`
      <div id="header-banner" class="header-banner" style="background-color: ${BANNER_BG_COLOR_CODE};">
        <div class="header-banner__wrap">
          <div class="header-banner__img">
            <a href="/terms/pdf/20250228">
              <img
                src="//s3.marpple.co/files/u_4214566/2025/3/original/e7c09a06d8cabf13a4321f0128525c90bc504aa52.png"
                alt="이용약관 개정 안내 | 2025년 4월 7일부로 이용약관이 개정될 예정입니다. | 주요 개정 사항 및 개정 전문 확인하기"
              />
            </a>
          </div>
          <div class="header-banner__btn-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M2.89062 2.1084L17.8906 17.1084M2.89062 17.1084L17.8906 2.1084"
                stroke="black"
                stroke-width="1.25"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </div>
    `;
  };

  const active_sub_menu = find((menu) => {
    return menu.active;
  }, sub_menus);

  const subInteractiveMenuHTML = sub_interactive_items
    ? new SubInteractiveMenu({ ...sub_interactive_items, className: 'utm_gnb_2' })
    : '';

  return html`
    ${headerBannerHTML()}
    <div class="omp-header" data-header_banner="${header_banner_type}">
      <div class="omp-header__wrap">
        <h1 id="logo" class="omp-header__logo">
          <a class="omp-header__logo-a" href="/${TT.lang}/">
            <img
              class="omp-header__logo-img"
              src="//s3.marpple.co/files/u_218933/2023/7/original/f01a70531eac8ab8ced3654146a153db12da80a91.svg"
              alt="MARPPLE"
            />
          </a>
        </h1>
        <div class="omp-header__body">
          <div class="omp-header__body-scroll">${headerSearchFormHTML('default', search_value)}</div>
        </div>
        <div class="omp-header__right">
          <div class="omp-header__buttons">
            ${OMPCoreCellTmplS.sideHeaderPc({
              wish_count,
              cart_count,
            })}
          </div>
        </div>
      </div>
      <div class="omp-header__menus omp-header__gnb-menus utm_gnb" data-active_id="${active_sub_menu?.id}">
        ${defaultHeaderMenu({ sub_menu_all, sub_menus })}
      </div>
      <div class="omp-header__navi">
        <div class="omp-header__navi-bg"></div>
        <div class="omp-header__navi-body"></div>
      </div>
      ${subInteractiveMenuHTML ? subInteractiveMenuHTML.toHtml(true) : ''}
    </div>
  `;
};

const detailHeaderHTML = ({
  sub_menus,
  wish_count,
  cart_count,
  search_value,
  header_banner_type,
  sub_interactive_items,
} = {}) => {
  const headerBannerHTML = () => {
    if (!header_banner_type) return '';
    const BANNER_BG_COLOR_CODE = '#E8E8E8'; // 띠배너 배경코드
    return html`
      <div id="header-banner" class="header-banner" style="background-color: ${BANNER_BG_COLOR_CODE};">
        <div class="header-banner__wrap">
          <div class="header-banner__img">
            <a href="/terms/pdf/20250228">
              <img
                src="//s3.marpple.co/files/u_4214566/2025/3/original/e7c09a06d8cabf13a4321f0128525c90bc504aa52.png"
                alt="이용약관 개정 안내 | 2025년 4월 7일부로 이용약관이 개정될 예정입니다. | 주요 개정 사항 및 개정 전문 확인하기"
              />
            </a>
          </div>
          <div class="header-banner__btn-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M2.89062 2.1084L17.8906 17.1084M2.89062 17.1084L17.8906 2.1084"
                stroke="black"
                stroke-width="1.25"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </div>
    `;
  };

  const active_sub_menu = find((menu) => {
    return menu.active;
  }, sub_menus);

  const subInteractiveMenuHTML = sub_interactive_items ? new SubInteractiveMenu(sub_interactive_items) : '';
  return html`
    ${headerBannerHTML()}
    <div class="omp-header" data-header_banner="${header_banner_type}">
      <div class="omp-header__wrap">
        <h1 id="logo" class="omp-header__logo">
          <a class="omp-header__logo-a" href="/${TT.lang}/">
            <img
              class="omp-header__logo-img"
              src="//s3.marpple.co/files/u_218933/2023/7/original/f01a70531eac8ab8ced3654146a153db12da80a91.svg"
              alt="MARPPLE"
            />
          </a>
        </h1>
        <div class="omp-header__body">
          ${new SubMenuNavAll({
            label: TT('omp_layout::menu_all'),
          }).toHtml(true)}
          <div class="omp-header__menus" data-active_id="${active_sub_menu?.id}">
            ${new SubMenuSwiper({
              items: sub_menus.map((sub_menu, index) => ({
                id: sub_menu.id,
                label: sub_menu.name,
                link: sub_menu.link.href,
                index,
              })),
              activeId: active_sub_menu?.id,
            }).toHtml(true)}
          </div>
        </div>
        <div class="omp-header__body-scroll">${headerSearchFormHTML('detail', search_value)}</div>
        <div class="omp-header__right">
          <div class="omp-header__buttons">
            ${OMPCoreCellTmplS.sideHeaderPc({
              wish_count,
              cart_count,
            })}
          </div>
        </div>
        <div class="omp-header__navi">
          <div class="omp-header__navi-bg"></div>
          <div class="omp-header__navi-body"></div>
        </div>
      </div>
      ${subInteractiveMenuHTML ? subInteractiveMenuHTML.toHtml(true) : ''}
    </div>
  `;
};
